// Fully updated models by category – as of September 2026
export const modelsByCategory = {
  "Smartphones": {
    "Apple": [
      "iPhone 18 Pro Max", "iPhone 18 Pro", "iPhone 18 Plus", "iPhone 18",
      "iPhone Fold",
      "iPhone 17 Pro Max", "iPhone 17 Pro", "iPhone 17 Plus", "iPhone 17", "iPhone 17e",
      "iPhone 16 Pro Max", "iPhone 16 Pro", "iPhone 16 Plus", "iPhone 16",
      "iPhone 15 Pro Max", "iPhone 15 Pro", "iPhone 15 Plus", "iPhone 15",
      "iPhone 14 Pro Max", "iPhone 14 Pro", "iPhone 14 Plus", "iPhone 14",
      "iPhone SE (4th gen)", "iPhone SE (3rd gen)", "iPhone SE (2nd gen)"
    ],
    "Samsung": [
      "Galaxy S26 Ultra", "Galaxy S26+", "Galaxy S26",
      "Galaxy S25 Ultra", "Galaxy S25+", "Galaxy S25",
      "Galaxy S24 Ultra", "Galaxy S24+", "Galaxy S24",
      "Galaxy S23 Ultra", "Galaxy S23+", "Galaxy S23",
      "Galaxy Z Fold 8 Ultra", "Galaxy Z Fold 8", "Galaxy Z Flip 8",
      "Galaxy Z Fold 7", "Galaxy Z Flip 7",
      "Galaxy Z Fold 6", "Galaxy Z Flip 6",
      "Galaxy Z TriFold",
      "Galaxy A57", "Galaxy A37", "Galaxy A76", "Galaxy A75",
      "Galaxy A56", "Galaxy A55", "Galaxy A36", "Galaxy A35",
      "Galaxy A26", "Galaxy A25", "Galaxy A16", "Galaxy A15",
      "Galaxy A06", "Galaxy A05",
      "Galaxy M55", "Galaxy M35", "Galaxy M15", "Galaxy F55", "Galaxy F15"
    ],
    "Google": [
      "Pixel 11 Pro Fold", "Pixel 11 Pro XL", "Pixel 11 Pro", "Pixel 11",
      "Pixel 10 Pro Fold", "Pixel 10 Pro", "Pixel 10", "Pixel 10a",
      "Pixel 9 Pro Fold", "Pixel 9 Pro", "Pixel 9", "Pixel 9a",
      "Pixel 8 Pro", "Pixel 8", "Pixel 8a",
      "Pixel 7 Pro", "Pixel 7", "Pixel 7a"
    ],
    "OnePlus": [
      "OnePlus 16", "OnePlus 15", "OnePlus 15T", "OnePlus 15R",
      "OnePlus 14", "OnePlus 13", "OnePlus 13R",
      "OnePlus 12", "OnePlus 12R",
      "OnePlus Open 2", "OnePlus Open",
      "OnePlus Nord 5", "OnePlus Nord 5R",
      "OnePlus Nord 4", "OnePlus Nord CE 4", "OnePlus Nord CE 3"
    ],
    "Xiaomi": [
      "Xiaomi 18 Ultra", "Xiaomi 18 Pro", "Xiaomi 18", "Xiaomi 18 Fold",
      "Xiaomi 17 Ultra", "Xiaomi 17 Pro", "Xiaomi 17",
      "Xiaomi 15 Ultra", "Xiaomi 15 Pro", "Xiaomi 15",
      "Xiaomi 14 Ultra", "Xiaomi 14 Pro", "Xiaomi 14",
      "Redmi Note 14 Pro+", "Redmi Note 14 Pro", "Redmi Note 14",
      "Redmi Note 13 Pro+", "Redmi Note 13 Pro", "Redmi Note 13",
      "POCO F9 Ultra", "POCO F9 Pro", "POCO F9",
      "POCO F8 Ultra", "POCO F7 Ultra", "POCO F7 Pro",
      "POCO X8 Pro Max", "POCO X8 Pro", "POCO X7 Pro", "POCO X6",
      "POCO M6 Pro", "POCO M6"
    ],
    "Oppo": [
      "Find X10 Ultra", "Find X10 Pro", "Find X10",
      "Find X9 Ultra", "Find X9 Pro", "Find X9",
      "Find X8 Pro", "Find X8", "Find X7 Ultra", "Find X7",
      "Reno 13 Pro", "Reno 13", "Reno 12 Pro", "Reno 12",
      "Reno 11 Pro", "Reno 11",
      "A98 5G", "A78 5G", "A58 5G", "A38", "A18",
      "F27 Pro+", "F25 Pro", "F23"
    ],
    "Vivo": [
      "X500 Ultra", "X500 Pro", "X500",
      "X300 Ultra", "X300 Pro", "X300",
      "X200 Pro", "X200", "X100 Pro", "X100",
      "V40 Pro", "V40", "V30 Pro", "V30", "V29e", "V27 Pro",
      "Y200 5G", "Y100 5G", "Y56 5G", "Y36", "Y28", "Y18",
      "T3 Pro", "T3 5G", "T2 Pro", "T2 5G"
    ],
    "Realme": [
      "GT 7 Pro", "GT 7", "GT 6", "GT 6T", "GT 5 Pro", "GT 5",
      "13 Pro+", "13 Pro", "13", "12 Pro+", "12 Pro", "12",
      "P4 Power", "P2 Pro", "P1 Pro 5G", "P1 5G",
      "C67 5G", "C65 5G", "C55", "C51",
      "Note 60", "Note 50"
    ],
    "Honor": [
      "Magic 9 Pro", "Magic 9", "Magic 9 RSR",
      "Magic 8 RSR", "Magic 8 Pro", "Magic 8",
      "Magic V6", "Magic V3",
      "Magic 7 Pro", "Magic 7", "Magic 6 Pro", "Magic 6",
      "200 Pro", "200", "100 Pro", "100", "90 Pro", "90",
      "X9c 5G", "X9b 5G", "X8b", "X7c", "X6a"
    ],
    "Huawei": [
      "Mate 90 Pro", "Mate 90", "Mate XT 2",
      "Mate 70 Pro+", "Mate 70 Pro", "Mate 70",
      "P70 Pro", "P70", "Nova 14 Pro", "Nova 14"
    ],
    "Motorola": [
      "Razr Fold", "Razr 70 Ultra", "Razr 70",
      "Razr 60 Ultra", "Razr 60", "Razr 50 Ultra", "Razr 50",
      "Edge 50 Ultra", "Edge 50 Pro", "Edge 50 Fusion", "Edge 50",
      "Edge 40 Pro", "Edge 40",
      "Moto G Power 2026", "Moto G Stylus 2026", "Moto G 2026",
      "Moto G84", "Moto G54", "Moto G34", "Moto G14"
    ],
    "Nothing": [
      "Phone (4a) Pro", "Phone (4a)",
      "Phone (3)", "Phone (3a)", "Phone (3a) Plus",
      "Phone (2)", "Phone (2a)", "Phone (2a) Plus",
      "Phone (1)", "CMF Phone 1"
    ],
    "iQOO": [
      "iQOO 16 Pro", "iQOO 16",
      "iQOO 15 Pro", "iQOO 15",
      "iQOO Neo 10 Pro", "iQOO Neo 10",
      "iQOO Z10 Turbo", "iQOO Z10", "iQOO Z9 Turbo"
    ]
  },

  "Tablets": {
    "Apple": [
      "iPad Pro 13 (M5)", "iPad Pro 11 (M5)",
      "iPad Pro 13 (M4)", "iPad Pro 11 (M4)",
      "iPad Air 13 (M3)", "iPad Air 11 (M3)",
      "iPad Air 13 (M2)", "iPad Air 11 (M2)",
      "iPad 12th Gen", "iPad 11th Gen", "iPad 10th Gen",
      "iPad mini 7", "iPad mini 6"
    ],
    "Samsung": [
      "Galaxy Tab S11 Ultra", "Galaxy Tab S11+", "Galaxy Tab S11",
      "Galaxy Tab S10 Ultra", "Galaxy Tab S10+", "Galaxy Tab S10",
      "Galaxy Tab S9 Ultra", "Galaxy Tab S9+", "Galaxy Tab S9",
      "Galaxy Tab A9+", "Galaxy Tab A9", "Galaxy Tab A8",
      "Galaxy Tab S6 Lite (2026)", "Galaxy Tab S6 Lite (2024)"
    ],
    "Lenovo": [
      "Tab P12 Pro Gen 2", "Tab P12 Pro",
      "Tab P11 Pro Gen 3", "Tab P11 Pro Gen 2",
      "Tab M10 Plus Gen 4", "Tab M10 Plus Gen 3",
      "Tab M9 Gen 2", "Tab M9", "Tab M8 Gen 3",
      "Yoga Tab 13", "Yoga Tab 11",
      "Moto Pad (2026)"
    ],
    "Microsoft": [
      "Surface Pro 11", "Surface Pro 10", "Surface Pro 9",
      "Surface Go 4", "Surface Go 3",
      "Surface Laptop Studio 3", "Surface Laptop Studio 2"
    ],
    "Google": [
      "Pixel Tablet 2", "Pixel Tablet"
    ],
    "Xiaomi": [
      "Xiaomi Pad 8 Pro", "Xiaomi Pad 8",
      "Xiaomi Pad 7 Pro", "Xiaomi Pad 7", "Xiaomi Pad 6 Pro", "Xiaomi Pad 6",
      "Redmi Pad SE 2", "Redmi Pad SE", "Redmi Pad Pro", "Redmi Pad",
      "POCO Pad"
    ],
    "TCL": [
      "TCL Note A1"
    ],
    "Oppo": [
      "Oppo Pad 3 Pro", "Oppo Pad 3", "Oppo Pad 2", "Oppo Pad",
      "Oppo Pad Air 2", "Oppo Pad Air"
    ],
    "Vivo": [
      "Vivo Pad 3 Pro", "Vivo Pad 3", "Vivo Pad 2", "Vivo Pad"
    ],
    "Honor": [
      "Honor Pad 9 Pro", "Honor Pad 9", "Honor Pad X9", "Honor Pad X8a",
      "Honor Pad 8 Pro", "Honor Pad 8"
    ],
    "OnePlus": [
      "OnePlus Pad 2", "OnePlus Pad"
    ],
    "Amazon": [
      "Fire Max 11 (2026)", "Fire Max 11",
      "Fire HD 10 (2026)", "Fire HD 10 (2025)",
      "Fire HD 8 (2026)", "Fire HD 8 (2025)",
      "Fire 7 (2026)", "Fire 7 (2025)"
    ]
  },

  "Laptops": {
    "Apple": [
      "MacBook Pro 16 M5 Max", "MacBook Pro 16 M5 Pro", "MacBook Pro 14 M5 Max", "MacBook Pro 14 M5 Pro", "MacBook Pro 14 M5",
      "MacBook Pro 16 M4 Max", "MacBook Pro 16 M4 Pro", "MacBook Pro 14 M4 Max", "MacBook Pro 14 M4 Pro", "MacBook Pro 14 M4",
      "MacBook Air 15 M5", "MacBook Air 13 M5",
      "MacBook Air 15 M4", "MacBook Air 13 M4",
      "MacBook Air 15 M3", "MacBook Air 13 M3",
      "MacBook Air 15 M2", "MacBook Air 13 M2",
      "Mac Studio (M5 Ultra)", "Mac Studio (M5 Max)"
    ],
    "Dell": [
      "XPS 16 (2026)", "XPS 14 (2026)", "XPS 13 (2026)",
      "XPS 15 (2025)", "XPS 13 (2025)",
      "Inspiron 16 Plus 7640", "Inspiron 14 Plus 7440", "Inspiron 15 3000",
      "Latitude 9550", "Latitude 7450", "Latitude 7350", "Latitude 5450",
      "Alienware m18 R3", "Alienware m16 R3", "Alienware x16 R2", "Alienware x14 R2",
      "G16 Gaming (2026)", "G15 Gaming (2026)", "G5 5000"
    ],
    "HP": [
      "Spectre x360 16 (2026)", "Spectre x360 14 (2026)",
      "Spectre x360 15 (2025)", "Spectre x360 13 (2025)",
      "Envy 17 (2026)", "Envy 15 (2026)", "Envy 13 (2026)",
      "OmniBook 3 17",
      "Pavilion Plus 16 (2026)", "Pavilion 15 (2026)", "Pavilion 14 (2026)",
      "Omen 40L", "Omen 17 (2026)", "Omen 16 (2026)",
      "Victus 16 (2026)", "Victus 15 (2026)",
      "EliteBook 1060 G11", "EliteBook 840 G11", "EliteBook 640 G11"
    ],
    "Lenovo": [
      "ThinkPad X1 Carbon Gen 13", "ThinkPad X1 Carbon Gen 12",
      "ThinkPad X1 Nano Gen 4", "ThinkPad X1 Nano Gen 3",
      "ThinkPad T16 Gen 4", "ThinkPad T14s Gen 5", "ThinkPad T14 Gen 5",
      "Legion 9i (2026)", "Legion 7i (2026)", "Legion 5i Pro (2026)", "Legion 5i (2026)",
      "Yoga 9i (2026)", "Yoga 7i (2026)", "Yoga 6 (2026)",
      "IdeaPad Pro 5i", "IdeaPad Slim 5", "IdeaPad 3"
    ],
    "ASUS": [
      "ROG Zephyrus G16 (2026)", "ROG Zephyrus G14 (2026)",
      "ROG Zephyrus M16", "ROG Zephyrus Duo 16",
      "ROG Strix SCAR 18", "ROG Strix SCAR 16",
      "ROG Strix G18", "ROG Strix G16",
      "Zenbook S 16", "Zenbook 14 OLED", "Zenbook 13 OLED",
      "Vivobook S 16", "Vivobook 15", "Vivobook 14", "Vivobook 13",
      "TUF Gaming A18", "TUF Gaming F16", "TUF Gaming A15", "TUF Gaming F15"
    ],
    "Acer": [
      "Swift 14 AI", "Swift 14", "Swift 5", "Swift 3",
      "Swift Go 16", "Swift Go 14", "Swift Go 13",
      "Aspire Vero 16", "Aspire 5", "Aspire 3",
      "Nitro 17 (2026)", "Nitro 16 (2026)", "Nitro 5",
      "Predator Helios 18", "Predator Helios 16", "Predator Triton 14"
    ],
    "Microsoft": [
      "Surface Laptop Studio 3", "Surface Laptop Studio 2",
      "Surface Laptop 7", "Surface Laptop 6", "Surface Laptop 5",
      "Surface Pro 11", "Surface Pro 10", "Surface Pro 9",
      "Surface Go 4", "Surface Go 3",
      "Surface Laptop Go 4", "Surface Laptop Go 3"
    ],
    "Samsung": [
      "Galaxy Book6 Pro 360", "Galaxy Book6 Pro", "Galaxy Book6 360", "Galaxy Book6",
      "Galaxy Book5 Pro 360", "Galaxy Book5 Pro", "Galaxy Book5 360", "Galaxy Book5",
      "Galaxy Book4 Ultra", "Galaxy Book4 Pro 360", "Galaxy Book4 Pro", "Galaxy Book4",
      "Galaxy Book3 Ultra", "Galaxy Book3 Pro 360", "Galaxy Book3 Pro"
    ],
    "MSI": [
      "Prestige 13 AI+", "Prestige 16 AI+",
      "Raider 16 Max HX (2026)", "Raider GE78 HX", "Raider GE68 HX",
      "Stealth 18 Studio", "Stealth 16 Studio", "Stealth 14 Studio",
      "Modern 15", "Modern 14", "Modern 13",
      "Cyborg 15", "Cyborg 14", "Sword 17", "Sword 16"
    ],
    "Razer": [
      "Blade 18 (2026)", "Blade 16 (2026)", "Blade 14 (2026)",
      "Blade 18 (2025)", "Blade 16 (2025)", "Blade 14 (2025)",
      "Blade Stealth 13", "Blade Pro 17"
    ]
  },

  "Headphones": {
    "Sony": [
      "WH-1000XM6", "WH-1000XM5", "WH-1000XM4", "WH-1000XM3",
      "WF-1000XM6", "WF-1000XM5", "WF-1000XM4", "WF-1000XM3",
      "WH-CH720N", "WH-CH710N", "WH-CH520",
      "LinkBuds 2", "LinkBuds S", "LinkBuds",
      "ULT Wear", "ULT Field 7", "ULT Field 5"
    ],
    "Bose": [
      "QuietComfort Ultra 2", "QuietComfort Ultra",
      "QuietComfort 55", "QuietComfort 45", "QuietComfort 35 II",
      "QuietComfort Earbuds III", "QuietComfort Earbuds II", "QuietComfort Earbuds",
      "Sport Earbuds", "Sport Open Earbuds",
      "Noise Cancelling Headphones 700", "SoundLink Around-Ear Wireless II"
    ],
    "Apple": [
      "AirPods Max 2", "AirPods Max",
      "AirPods Pro 3", "AirPods Pro 2", "AirPods Pro",
      "AirPods 4", "AirPods 3", "AirPods 2", "AirPods",
      "Beats Studio Pro 2", "Beats Studio Pro",
      "Beats Fit Pro 2", "Beats Fit Pro",
      "Beats Solo 4", "Beats Solo 3",
      "Beats Powerbeats Pro 2", "Beats Powerbeats Pro"
    ],
    "Sennheiser": [
      "Momentum 5 Wireless", "Momentum 4 Wireless", "Momentum 3 Wireless",
      "Momentum True Wireless 5", "Momentum True Wireless 4", "Momentum True Wireless 3", "Momentum True Wireless 2",
      "HD 700", "HD 660S2", "HD 660S", "HD 650", "HD 600",
      "HD 599", "HD 560S", "HD 450BT", "HD 350BT"
    ],
    "JBL": [
      "Tour One M3", "Tour One M2", "Tour Pro 3", "Tour Pro 2",
      "Live 770NC", "Live 670NC", "Live 460NC", "Live 310BT",
      "Tune 770NC", "Tune 670NC", "Tune 520BT", "Tune 230NC TWS",
      "Endurance Peak 4", "Endurance Peak 3", "Endurance Race 2"
    ],
    "Audio-Technica": [
      "ATH-M50xBT2", "ATH-M50x", "ATH-M40x", "ATH-M20x",
      "ATH-SQ1TW", "ATH-CKS50TW", "ATH-CK1TW", "ATH-SPORT5TW",
      "ATH-ANC300TW", "ATH-ANC900BT", "ATH-SR50BT", "ATH-WS990BT"
    ],
    "Samsung": [
      "Galaxy Buds 4 Pro", "Galaxy Buds 4",
      "Galaxy Buds 3 Pro", "Galaxy Buds 3", "Galaxy Buds 2 Pro", "Galaxy Buds 2",
      "Galaxy Buds Live", "Galaxy Buds Pro", "Galaxy Buds FE", "Galaxy Buds+"
    ],
    "Google": [
      "Pixel Buds Pro 2", "Pixel Buds Pro",
      "Pixel Buds 2a", "Pixel Buds A-Series"
    ],
    "Sonos": [
      "Ace Ultra", "Ace"
    ],
    "Xiaomi": [
      "Redmi Buds 6 Pro", "Redmi Buds 6", "Redmi Buds 5 Pro", "Redmi Buds 5",
      "Xiaomi Buds 5", "Xiaomi Buds 4 Pro", "Xiaomi Buds 4",
      "Mi True Wireless 3", "Mi True Wireless 2"
    ],
    "Marshall": [
      "Monitor III", "Monitor II A.N.C.", "Monitor",
      "Major V", "Major IV", "Major III",
      "Minor IV", "Minor III", "Minor II",
      "Motif II A.N.C.", "Motif A.N.C.",
      "Mid A.N.C.", "Mode II"
    ],
    "Bowers & Wilkins": [
      "Px8", "Px7 S2e", "Px7 S2", "Px5",
      "Pi8", "Pi7 S2", "Pi7", "Pi5 S2", "Pi5",
      "Formation Duo", "Formation Wedge", "Zeppelin"
    ],
    "Master & Dynamic": [
      "MW09", "MW08", "MW07 Plus",
      "MW75", "MW65", "MW60",
      "MG20", "MH40", "ME05"
    ],
    "Fender": [
      "Cruiser Wireless", "Mustang Micro+"
    ],
    "EarFun": [
      "Wave Pro X", "Air Pro 4+", "Air Pro 4", "Air 2 Pro"
    ]
  },

  "Speakers": {
    "Sonos": [
      "Beam Ultra", "Arc Ultra", "Arc",
      "Era 300", "Era 100",
      "Move 2", "Move",
      "Roam 2", "Roam",
      "Beam Gen 2", "Beam Gen 1",
      "Ray", "Five", "Play:5",
      "Sub Mini", "Sub Gen 3",
      "Portable", "One SL", "One"
    ],
    "Bose": [
      "SoundLink Max 2", "SoundLink Max", "SoundLink Revolve+ III", "SoundLink Revolve II",
      "Smart Ultra Soundbar", "Smart Soundbar 900", "Smart Soundbar 600",
      "Portable Home Speaker", "Home Speaker 500",
      "SoundLink Flex 2", "SoundLink Flex",
      "SoundLink Color II", "SoundLink Micro"
    ],
    "Sony": [
      "SRS-RA5000", "SRS-RA3000",
      "SRS-XE300", "SRS-XE200",
      "SRS-XG300", "SRS-XG500",
      "SRS-XB43", "SRS-XB33", "SRS-XB23",
      "ULT Tower 7", "ULT Tower 5",
      "HT-A7000 Soundbar", "HT-A5000 Soundbar", "HT-A3000 Soundbar",
      "HT-S2000 Soundbar", "HT-X9000 Soundbar"
    ],
    "JBL": [
      "PartyBox Ultimate", "PartyBox Encore", "PartyBox 320", "PartyBox 120", "PartyBox 110",
      "Flip 7", "Flip 6", "Flip 5", "Flip 4",
      "Charge 6", "Charge 5", "Charge 4", "Charge 3",
      "Xtreme 4", "Xtreme 3", "Xtreme 2",
      "BoomBox 3", "BoomBox 2", "BoomBox",
      "Pulse 6", "Pulse 5", "Pulse 4",
      "Clip 5", "Clip 4", "Go 4", "Go 3"
    ],
    "Marshall": [
      "Stanmore III", "Stanmore II",
      "Acton III", "Acton II",
      "Woburn III", "Woburn II",
      "Emberton III", "Emberton II", "Emberton",
      "Willen II", "Willen",
      "Kilburn II", "Kilburn", "Tufton", "Stockwell II"
    ],
    "Apple": [
      "HomePod 2", "HomePod (1st gen)",
      "HomePod Mini"
    ],
    "Amazon": [
      "Echo Studio (2026)", "Echo Studio",
      "Echo Show 15", "Echo Show 10 (2026)", "Echo Show 8 (2026)", "Echo Show 5 (2026)",
      "Echo Dot (5th Gen)", "Echo Dot (4th Gen)",
      "Echo Pop", "Echo Pop Kids",
      "Echo (4th Gen)", "Echo (3rd Gen)",
      "Echo Auto"
    ],
    "Google": [
      "Nest Audio 2", "Nest Audio",
      "Nest Hub Max", "Nest Hub (3rd Gen)", "Nest Hub (2nd Gen)",
      "Nest Mini", "Home Mini", "Home Max"
    ],
    "Bang & Olufsen": [
      "Beosound A5", "Beosound A1 (2nd Gen)", "Beosound Explore",
      "Beosound Emerge", "Beosound Balance",
      "Beolit 20", "Beolit 17",
      "Beoplay A1", "Beoplay P6", "Beoplay P2"
    ],
    "Ultimate Ears": [
      "EPICBOOM", "MEGABOOM 4", "MEGABOOM 3",
      "BOOM 4", "BOOM 3", "BOOM 2",
      "WONDERBOOM 4", "WONDERBOOM 3", "WONDERBOOM 2",
      "ROLL 3", "ROLL 2"
    ],
    "Klipsch": [
      "The Fives (2026)", "The Fives", "The Sixes",
      "T5 II True Wireless ANC", "T10 True Wireless"
    ],
    "LG": [
      "Xboom 360 (2026)", "Xboom Go PL7", "Xboom Go PL5",
      "Eclair QP5", "Eclair SE6",
      "LG Sound Suite"
    ]
  },

  "Cameras": {
    "Canon": [
      "EOS R5 Mark II", "EOS R5", "EOS R6 Mark III", "EOS R6 Mark II", "EOS R6",
      "EOS R8", "EOS R7", "EOS R10", "EOS R50", "EOS R100",
      "EOS RP", "EOS R",
      "EOS 5D Mark V", "EOS 6D Mark III", "EOS 90D", "EOS 850D",
      "PowerShot V10", "PowerShot G7 X Mark IV", "PowerShot G5 X Mark III", "PowerShot SX740 HS"
    ],
    "Sony": [
      "A1 II", "A1", "A7R VI", "A7R V", "A7R IV",
      "A7 IV", "A7 III", "A7C II", "A7C",
      "ZV-E10 II", "ZV-E10", "ZV-1F", "ZV-1 II", "ZV-1",
      "RX100 VIII", "RX100 VII", "RX100 VI",
      "FX6", "FX3", "FX30"
    ],
    "Nikon": [
      "Z9", "Z8", "Z7 II", "Z7", "Z6 III", "Z6 II", "Z6",
      "Z5 II", "Z5", "Z50 II", "Z50", "Z30", "Z fc 2", "Z fc",
      "D850", "D780", "D7500", "D5600",
      "Coolpix P1000", "Coolpix P950"
    ],
    "Fujifilm": [
      "X-H2S", "X-H2", "X-T5", "X-T4", "X-T3",
      "X100VI", "X100V", "X100F",
      "X-S20", "X-S10", "X-Pro4", "X-Pro3",
      "GFX100 II", "GFX100S II", "GFX100", "GFX50S II", "GFX50R",
      "X-E4", "X-T30 II", "X-T200"
    ],
    "Panasonic": [
      "Lumix S5 IIX", "Lumix S5 II", "Lumix S5",
      "Lumix GH7", "Lumix GH6", "Lumix GH5 II", "Lumix GH5",
      "Lumix G9 II", "Lumix G9", "Lumix G100",
      "Lumix S9", "Lumix S1H", "Lumix S1R", "Lumix S1",
      "Lumix FZ1000 II", "Lumix ZS200"
    ],
    "DJI": [
      "Osmo Pocket 4", "Osmo Pocket 3", "Osmo Pocket 2",
      "Osmo Action 5 Pro", "Osmo Action 5", "Osmo Action 4", "Osmo Action 3",
      "Osmo Mobile 7", "Osmo Mobile 6", "Osmo Mobile SE",
      "Ronin 4D", "Ronin SC 2", "Ronin SC", "Ronin S"
    ],
    "GoPro": [
      "Hero 14 Black", "Hero 13 Black", "Hero 12 Black", "Hero 11 Black", "Hero 10 Black", "Hero 9 Black",
      "Max 2", "Max",
      "Hero 13 Black Mini", "Hero 12 Black Mini", "Hero 11 Black Mini"
    ],
    "Leica": [
      "Q3 43", "Q3", "Q2", "Q",
      "M11-P", "M11", "M10-R", "M10",
      "SL3", "SL2", "SL",
      "D-Lux 8", "D-Lux 7", "V-Lux 3", "C-Lux"
    ],
    "OM System": [
      "OM-1 Mark III", "OM-1 Mark II", "OM-1", "OM-5",
      "TG-7", "TG-6", "TG-5"
    ]
  },

  "Home appliances": {
    "Hitachi": [
      "R-BG460P7S Refrigerator", "R-HW610RX Refrigerator", "R-SF48BM Refrigerator",
      "SF-140WV Washing Machine", "SF-100WV Washing Machine", "BD-90CV Washing Machine",
      "RAS-10NKF Air Conditioner", "RAS-13NKF Air Conditioner", "RAS-18NKF Air Conditioner",
      "PV-XH2000 Vacuum Cleaner", "PV-XH1000 Vacuum Cleaner"
    ],
    "Panasonic": [
      "NR-BY602X Refrigerator", "NR-BW460X Refrigerator", "NR-BW360X Refrigerator",
      "NA-FS14V3 Washing Machine", "NA-FS10V3 Washing Machine", "NA-FD13V3 Washing Machine",
      "CU/CS-YN9UK Air Conditioner", "CU/CS-YN12UK Air Conditioner", "CU/CS-YN18UK Air Conditioner",
      "SR-JHS189 Rice Cooker", "SR-JHS109 Rice Cooker", "SR-DF181 Rice Cooker",
      "MC-SB85K Vacuum Cleaner", "MC-CL665 Vacuum Cleaner",
      "NN-SN966S Microwave", "NN-ST64SM Microwave"
    ],
    "Mitsubishi Electric": [
      "MR-CX46E Refrigerator", "MR-LX46E Refrigerator",
      "MSZ-GE22VA Air Conditioner", "MSZ-GE25VA Air Conditioner", "MSZ-GE35VA Air Conditioner",
      "MA-V210W Washing Machine", "MA-V170W Washing Machine",
      "HC-V6000 Vacuum Cleaner", "HC-V5000 Vacuum Cleaner"
    ],
    "Sharp": [
      "SJ-FX680V Refrigerator", "SJ-FX560V Refrigerator", "SJ-FX480V Refrigerator",
      "ES-JF814 Washing Machine", "ES-JF710 Washing Machine", "ES-JF610 Washing Machine",
      "AY-ZP13 Air Conditioner", "AY-ZP10 Air Conditioner", "AY-ZP18 Air Conditioner",
      "EC-AR2 Vacuum Cleaner", "EC-AR1 Vacuum Cleaner",
      "Healsio AX-XP10 Microwave", "Healsio AX-XP5 Microwave"
    ],
    "LG": [
      "GC-B257SLV Refrigerator", "GC-B247SLV Refrigerator", "GC-B207SLV Refrigerator",
      "FH4G1JCHK6N Washing Machine", "FH4G1JCHK5N Washing Machine", "F4V5RYP0W Washing Machine",
      "DualCool Inverter Air Conditioner", "DualCool Air Conditioner",
      "CordZero A9K Vacuum Cleaner", "CordZero A9 Vacuum Cleaner",
      "NeoChef Smart Microwave", "NeoChef Microwave",
      "InstaView Range", "InstaView Oven"
    ],
    "Samsung": [
      "RS62R5031B4 Refrigerator", "RS62R5001B4 Refrigerator", "RT47R6531SL Refrigerator",
      "WW90T4040CE Washing Machine", "WW80T4040CE Washing Machine", "WW70T4040CE Washing Machine",
      "AR12TYHQA Air Conditioner", "AR10TYHQA Air Conditioner", "AR18TYHQA Air Conditioner",
      "Bespoke Jet Bot AI+", "Bespoke Jet Bot", "Bespoke Jet Vacuum", "Jet 90 Vacuum",
      "SmartThings Station", "SmartThings Hub"
    ],
    "Electrolux": [
      "EQTE3800AW Refrigerator", "EQTE3600AW Refrigerator", "EQTE3200AW Refrigerator",
      "EWF14042 Washing Machine", "EWF12042 Washing Machine", "EWF10042 Washing Machine",
      "ToughClean Vacuum Cleaner", "UltraSilencer Vacuum Cleaner", "Pure D9 Vacuum Cleaner",
      "CombiSteam Oven", "AirFry Oven"
    ],
    "Dyson": [
      "V15 Detect Absolute", "V15 Detect", "V12 Detect Slim",
      "V8 Slim", "V8 Absolute",
      "TP10 Purifier", "TP09 Purifier", "TP07 Purifier",
      "PH04 Humidify+Cool", "PH03 Humidify+Cool",
      "360 Vis Nav Robot Vacuum", "360 Heurist Robot Vacuum",
      "Supersonic r Hair Dryer", "Supersonic Hair Dryer", "Airwrap Styler", "Corrale Straightener"
    ],
    "Amazon": [
      "Echo Studio (2026)", "Echo Studio",
      "Echo Show 15", "Echo Show 10 (2026)", "Echo Show 8 (2026)", "Echo Show 5 (2026)",
      "Echo Dot (5th Gen)", "Echo Dot (4th Gen)", "Echo Pop",
      "Ring Video Doorbell 5", "Ring Video Doorbell 4", "Ring Stick Up Cam Pro", "Ring Floodlight Cam Pro",
      "Ring Alarm Pro", "Ring Chime Pro"
    ],
    "Google": [
      "Nest Hub (3rd Gen)", "Nest Hub (2nd Gen)", "Nest Hub Max",
      "Nest Thermostat (2026)", "Nest Thermostat E", "Nest Learning Thermostat",
      "Nest Protect", "Nest Cam Outdoor", "Nest Cam Indoor",
      "Nest Doorbell", "Nest Audio", "Nest Mini"
    ],
    "Apple": [
      "HomePod 2", "HomePod Mini",
      "Apple TV 4K (2026)", "Apple TV 4K (2022)", "Apple TV HD"
    ],
    "Philips Hue": [
      "Hue Bridge", "Hue White & Color Ambiance", "Hue White Ambiance", "Hue White",
      "Hue Play Gradient Lightstrip", "Hue Lightstrip Plus", "Hue Lily Outdoor",
      "Hue Secure Camera", "Hue Outdoor Sensor", "Hue Tap Dial"
    ],
    "Ring": [
      "Video Doorbell 5", "Video Doorbell 4", "Video Doorbell Pro 2",
      "Stick Up Cam Pro", "Stick Up Cam Elite", "Floodlight Cam Pro",
      "Alarm Pro", "Alarm Kit", "Chime Pro", "Chime"
    ],
    "Roborock": [
      "Saros Z70", "Saros 10R", "S8 MaxV Ultra", "S8 Pro Ultra", "S8",
      "Q Revo MaxV", "Q Revo", "Q7 Max", "Q5 Pro"
    ],
    "iRobot": [
      "Roomba j9+", "Roomba j7+", "Roomba i7+", "Roomba 694",
      "Roomba Combo j9+", "Roomba Combo i5+",
      "Braava jet m6", "Braava jet 240"
    ]
  },

  "TVs": {
    "LG": [
      "OLED G6 Series (77\", 65\", 55\")", "OLED G5 Series (83\", 77\", 65\", 55\")",
      "OLED C6 Series (83\", 77\", 65\", 55\", 48\", 42\")", "OLED C5 Series (83\", 77\", 65\", 55\", 48\", 42\")", "OLED C4 Series",
      "OLED M5 Series (97\", 83\", 77\")", "OLED M4 Series",
      "QNED99 MiniLED (2026)", "QNED95 Series (86\", 75\", 65\")", "QNED90 Series",
      "NanoCell 85 Series", "NanoCell 80 Series"
    ],
    "Samsung": [
      "S95F OLED (77\", 65\", 55\")", "S90F OLED (83\", 77\", 65\", 55\")",
      "S95D OLED", "S90D OLED",
      "QN990F Neo QLED 8K (85\", 75\", 65\")", "QN900F Neo QLED (85\", 75\", 65\")", "QN800F Neo QLED",
      "QN90F Neo QLED", "QN85F Neo QLED",
      "DU9000 Crystal UHD", "DU8000 Crystal UHD",
      "Frame Series (2026)", "Serif Series", "Sero Series",
      "The Terrace (2026)", "The Wall"
    ],
    "Sony": [
      "Bravia 6 OLED (2026)", "Bravia 7 II (2026)",
      "XR A95L OLED (77\", 65\", 55\")", "XR A95K OLED",
      "XR X95L (85\", 75\", 65\")", "XR X95K",
      "XR A90L OLED (83\", 55\")", "XR A80L OLED",
      "XR X90L (85\", 75\", 65\", 55\")", "XR X90K",
      "X85L", "X80L",
      "BRAVIA 9 Series", "BRAVIA 8 Series", "BRAVIA 7 Series"
    ],
    "TCL": [
      "QM9 QLED (98\", 85\", 75\")", "QM8 QLED (98\", 85\", 75\", 65\")", "QM7 QLED",
      "Q6 QLED", "Q5 QLED",
      "S6 Series", "S5 Series", "S4 Series",
      "C8 Series", "C7 Series", "C6 Series",
      "Google TV Series", "Roku TV Series"
    ],
    "Hisense": [
      "U9N ULED (85\", 75\", 65\")", "U9H ULED",
      "U8N ULED (85\", 75\", 65\", 55\")", "U8H ULED",
      "U7N ULED", "U7H ULED",
      "U6N ULED", "U6H ULED",
      "A7N Series", "A6H Series",
      "Laser TV TriChroma (2026)", "Laser TV Series", "L5F Series"
    ],
    "Panasonic": [
      "Z95A OLED (77\", 65\", 55\")", "Z90A OLED (65\", 55\")",
      "MX950 (75\", 65\", 55\")", "MX800 (65\", 55\", 50\", 43\")",
      "LX900", "LX700",
      "JZ2000", "JZ1500", "JZ1000"
    ],
    "Philips": [
      "OLED+ 959 (77\", 65\", 55\")", "OLED+ 909",
      "OLED 809 (77\", 65\", 55\", 48\")", "OLED 709",
      "PUS8808 (75\", 65\", 55\", 50\", 43\")", "PUS8508",
      "Ambilight Series", "The One Series"
    ],
    "Roku": [
      "Pro Series OLED (2026)", "Pro Series LX OLED",
      "Pro Series (2026)", "Select Series", "Express Series"
    ]
  },

  "Gaming Consoles": {
    "Sony": [
      "PlayStation 6", "PlayStation 5 Pro", "PlayStation 5 Slim", "PlayStation 5",
      "PlayStation 4 Pro", "PlayStation 4 Slim", "PlayStation 4",
      "PlayStation Portal", "PS VR2", "PS VR",
      "DualSense Edge Wireless Controller", "DualSense Wireless Controller",
      "Pulse 3D Wireless Headset", "Pulse Elite Wireless Headset"
    ],
    "Microsoft": [
      "Xbox Series X 2", "Xbox Series X", "Xbox Series S", "Xbox Series S (1TB)",
      "Xbox One X", "Xbox One S", "Xbox One",
      "Xbox Elite Controller 3", "Xbox Elite Series 2 Core Controller",
      "Xbox Wireless Headset", "Xbox Stereo Headset"
    ],
    "Nintendo": [
      "Switch 2", "Switch 2 Pro", "Switch 2 Lite",
      "Switch Pro", "Switch OLED", "Switch Lite", "Switch",
      "Joy-Con (L/R)", "Nintendo Switch Pro Controller",
      "NES Controller", "SNES Controller", "Nintendo 64 Controller",
      "GameCube Controller"
    ],
    "Valve": [
      "Steam Deck 2", "Steam Deck OLED", "Steam Deck (512GB)", "Steam Deck (256GB)", "Steam Deck (64GB)",
      "Steam Controller 2", "Steam Controller",
      "Steam Link"
    ],
    "Asus": [
      "ROG Ally X 2", "ROG Ally X", "ROG Ally (2024)", "ROG Ally (2023)",
      "ROG Raikiri Pro Controller", "ROG Raikiri Controller",
      "ROG Cetra True Wireless", "ROG Cetra Gaming Headset"
    ],
    "Lenovo": [
      "Legion Go 2", "Legion Go", "Legion Go Lite",
      "Legion M600 Gaming Mouse", "Legion K500 Pro Keyboard",
      "Legion H500 Pro Headset"
    ],
    "MSI": [
      "Claw 8 AI+", "Claw 7 AI+", "Claw A1M",
      "Force GC30 Controller", "Force GC20 Controller",
      "Immerse GH50 Headset", "Immerse GH40 Headset"
    ]
  },

  "Smartwatches": {
    "Apple": [
      "Apple Watch Ultra 4", "Apple Watch Ultra 3", "Apple Watch Ultra 2", "Apple Watch Ultra",
      "Apple Watch Series 11", "Apple Watch Series 10", "Apple Watch Series 9", "Apple Watch Series 8",
      "Apple Watch SE (3rd gen)", "Apple Watch SE (2nd gen)", "Apple Watch SE",
      "Apple Watch Hermès Series 11", "Apple Watch Hermès Series 10",
      "Apple Watch Nike Series 11", "Apple Watch Nike Series 10"
    ],
    "Samsung": [
      "Galaxy Watch Ultra 2", "Galaxy Watch Ultra",
      "Galaxy Watch 9 (44mm)", "Galaxy Watch 9 (40mm)",
      "Galaxy Watch 8 Pro", "Galaxy Watch 8",
      "Galaxy Watch 7 Pro", "Galaxy Watch 7",
      "Galaxy Watch 6 Classic", "Galaxy Watch 6",
      "Galaxy Watch 5 Pro", "Galaxy Watch 5",
      "Galaxy Watch 4 Classic", "Galaxy Watch 4",
      "Galaxy Watch 3", "Galaxy Watch Active 2", "Galaxy Watch Active"
    ],
    "Google": [
      "Pixel Watch 5", "Pixel Watch 3 (45mm)", "Pixel Watch 3 (41mm)", "Pixel Watch 2", "Pixel Watch",
      "Pixel Watch 3 XL", "Pixel Watch 2 LTE", "Pixel Watch LTE"
    ],
    "Garmin": [
      "Fenix 8 (51mm)", "Fenix 8 (47mm)", "Fenix 8 (42mm)", "Fenix 7 Pro", "Fenix 7",
      "Epix Pro Gen 2 (51mm)", "Epix Pro Gen 2 (47mm)", "Epix Pro Gen 2 (42mm)", "Epix Gen 2",
      "Forerunner 965", "Forerunner 265", "Forerunner 255", "Forerunner 165",
      "Venu 4", "Venu 3", "Venu Sq 2", "Vivoactive 6", "Vivoactive 5",
      "Instinct 3", "Instinct 2X", "Instinct Crossover",
      "Tactix 8", "Tactix 7 Pro", "MARQ 2 Collection"
    ],
    "Fitbit": [
      "Sense 3", "Sense 2", "Sense",
      "Versa 5", "Versa 4", "Versa 3", "Versa 2",
      "Charge 7", "Charge 6", "Charge 5", "Charge 4",
      "Inspire 4", "Inspire 3", "Inspire 2",
      "Luxe 2", "Luxe",
      "Ace 4", "Ace 3"
    ],
    "Xiaomi": [
      "Watch 2 Pro", "Watch 2", "Watch S3", "Watch S2",
      "Smart Band 9 Pro", "Smart Band 9", "Smart Band 8 Pro", "Smart Band 8",
      "Mi Watch Lite", "Mi Watch"
    ],
    "Huawei": [
      "Watch GT 5 Pro", "Watch GT 5", "Watch GT 4", "Watch GT 3 Pro", "Watch GT 3",
      "Watch Ultimate 2", "Watch Ultimate",
      "Watch D2", "Watch D", "Watch Fit 3", "Watch Fit 2", "Watch Fit"
    ],
    "Amazfit": [
      "T-Rex 3", "T-Rex 2", "T-Rex Pro",
      "GTR 4", "GTR 3 Pro", "GTR 3",
      "Balance 2", "Balance", "Cheetah Pro", "Cheetah",
      "Falcon", "Neo", "Pop 3S", "Pop 3R"
    ],
    "Withings": [
      "ScanWatch 2 (42mm)", "ScanWatch 2 (38mm)", "ScanWatch Nova (42mm)", "ScanWatch Nova (38mm)",
      "Body Scan", "Body Cardio",
      "Move ECG", "Move", "Steel HR Sport", "Steel HR",
      "ScanWatch Horizon", "ScanWatch Light"
    ],
    "OnePlus": [
      "OnePlus Watch 3", "OnePlus Watch 2", "OnePlus Watch",
      "OnePlus Nord Watch"
    ]
  }
};

// ===========================================
// Helper functions
// ===========================================

export const getBrandsByCategory = (category) => {
  if (!category) return [];

  if (category === 'home_appliances' || category === 'home appliances') {
    return Object.keys(modelsByCategory['Home appliances'] || {});
  }

  if (modelsByCategory[category]) {
    return Object.keys(modelsByCategory[category]);
  }

  const categoryLower = category.toLowerCase();
  const foundCategory = Object.keys(modelsByCategory).find(
    key => key.toLowerCase() === categoryLower
  );

  if (foundCategory) {
    return Object.keys(modelsByCategory[foundCategory]);
  }

  const partialMatch = Object.keys(modelsByCategory).find(
    key => key.toLowerCase().includes(categoryLower)
  );

  if (partialMatch) {
    return Object.keys(modelsByCategory[partialMatch]);
  }

  return [];
};

export const getModelsByBrandAndCategory = (category, brand) => {
  if (!category || !brand) return [];

  if (category === 'home_appliances' || category === 'home appliances') {
    if (modelsByCategory['Home appliances'] && modelsByCategory['Home appliances'][brand]) {
      return modelsByCategory['Home appliances'][brand];
    }
  }

  if (modelsByCategory[category] && modelsByCategory[category][brand]) {
    return modelsByCategory[category][brand];
  }

  const categoryLower = category.toLowerCase();
  const foundCategory = Object.keys(modelsByCategory).find(
    key => key.toLowerCase() === categoryLower || key.toLowerCase().includes(categoryLower)
  );

  if (foundCategory && modelsByCategory[foundCategory][brand]) {
    return modelsByCategory[foundCategory][brand];
  }

  if (foundCategory) {
    const brandLower = brand.toLowerCase();
    const foundBrand = Object.keys(modelsByCategory[foundCategory]).find(
      key => key.toLowerCase() === brandLower
    );

    if (foundBrand) {
      return modelsByCategory[foundCategory][foundBrand];
    }
  }

  return [];
};

export const getAllCategories = () => {
  return Object.keys(modelsByCategory);
};

// For backward compatibility
export const modelsByBrand = Object.keys(modelsByCategory).reduce((acc, category) => {
  Object.entries(modelsByCategory[category]).forEach(([brand, models]) => {
    acc[brand] = [...(acc[brand] || []), ...models];
  });
  return acc;
}, {});

// Get all products for matching service
export const getAllProducts = () => {
  const products = [];
  Object.entries(modelsByCategory).forEach(([category, brands]) => {
    Object.entries(brands).forEach(([brand, models]) => {
      models.forEach(model => {
        products.push({ brand, model, category });
      });
    });
  });
  return products;
};

// Get products by category (case-insensitive)
export const getProductsByCategory = (category) => {
  if (!category) return [];

  if (category === 'home_appliances' || category === 'home appliances') {
    const products = [];
    Object.entries(modelsByCategory['Home appliances'] || {}).forEach(([brand, models]) => {
      models.forEach(model => {
        products.push({ brand, model, category: 'Home appliances' });
      });
    });
    return products;
  }

  const categoryLower = category.toLowerCase();
  const foundCategory = Object.keys(modelsByCategory).find(
    key => key.toLowerCase() === categoryLower || key.toLowerCase().includes(categoryLower)
  );

  if (!foundCategory) return [];

  const products = [];
  Object.entries(modelsByCategory[foundCategory]).forEach(([brand, models]) => {
    models.forEach(model => {
      products.push({ brand, model, category: foundCategory });
    });
  });
  return products;
};